import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox"

import { faCircle as faCircleLight, faSquare } from "@fortawesome/pro-light-svg-icons"
import { faCircleCheck, faCircleEllipsis, faSquareCheck, faSquareEllipsis } from "@fortawesome/pro-solid-svg-icons"

enum IconType {
    circle = "circle",
    square = "square",
}

const ICON_COLOR = "#101941"
const ICON_COLOR_DISABLED = "#70758D"

type Props = CheckboxProps & {
    iconType?: IconType
}

const MuiCheckbox = (props: Props) => {
    const { sx, ...rest } = props
    const getUncheckedIcon = () => {
        switch (props.iconType) {
            case IconType.circle:
                return (
                    <FontAwesomeIcon
                        icon={faCircleLight}
                        size="lg"
                        color={props.disabled ? ICON_COLOR_DISABLED : ICON_COLOR}
                    />
                )
            default:
                return (
                    <FontAwesomeIcon
                        icon={faSquare}
                        size="lg"
                        color={props.disabled ? ICON_COLOR_DISABLED : ICON_COLOR}
                    />
                )
        }
    }

    const getCheckedIcon = () => {
        switch (props.iconType) {
            case IconType.circle:
                return (
                    <FontAwesomeIcon
                        icon={faCircleCheck}
                        size="lg"
                        color={props.disabled ? ICON_COLOR_DISABLED : ICON_COLOR}
                    />
                )
            default:
                return (
                    <FontAwesomeIcon
                        icon={faSquareCheck}
                        size="lg"
                        color={props.disabled ? ICON_COLOR_DISABLED : ICON_COLOR}
                    />
                )
        }
    }

    const getIndeterminateIcon = () => {
        switch (props.iconType) {
            case IconType.circle:
                return (
                    <FontAwesomeIcon
                        icon={faCircleEllipsis}
                        size="lg"
                        color={props.disabled ? ICON_COLOR_DISABLED : ICON_COLOR}
                    />
                )
            default:
                return (
                    <FontAwesomeIcon
                        icon={faSquareEllipsis}
                        size="lg"
                        color={props.disabled ? ICON_COLOR_DISABLED : ICON_COLOR}
                    />
                )
        }
    }

    return (
        <Checkbox
            icon={getUncheckedIcon()}
            checkedIcon={getCheckedIcon()}
            indeterminateIcon={getIndeterminateIcon()}
            {...rest}
            sx={{
                padding: "2px",
                marginRight: 1,
                ...sx,
            }}
        />
    )
}

export default MuiCheckbox
